import KButton from 'app/components/Modules/General/KButton'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

export const damageInfoCardTestId = 'damage-info-card'
interface Props extends React.ComponentProps<typeof KCol> {
  rental?: IRental
}

const DamageInfoCard: React.FC<Props> = ({ rental, ...others }) => {
  const navigate = useNavigate()
  const { tComponent } = useTranslation({
    recordType: RecordType.damage_info,
    componentType: 'data_display',
    scope: 'card'
  })
  const hasDamages = rental?.damagesCount > 0

  if (!rental || !hasDamages) return null

  const translate = (id: string) => tComponent({ id })
  const onClick = () => {
    navigate(Routes.Rental.member(String(rental?.id)).damage)
  }

  return (
    <KCol span={24} card data-testid={damageInfoCardTestId} {...others}>
      <h3 className="mb-0 white-space-normal">{translate('title')}</h3>
      <p className="mt-0">{translate('description')}</p>
      <KButton
        type="secondary"
        recordType={RecordType.damage_info}
        onClick={onClick}
        action="show_damage"
        ellipsis
        block
      />
    </KCol>
  )
}

export default DamageInfoCard
